// VR Experience component with AFrame iframe integration

import React, { useRef, useEffect } from 'react';
import { websocketService } from '../../services/websocketService';
import styles from './VRExperience.module.css';

const VRExperience = ({ wsState }) => {
  const iframeRef = useRef(null);
  const { attachIframe, detachIframe } = wsState;

  useEffect(() => {
    const iframe = iframeRef.current;

    const handleIframeLoad = () => {
      console.log('[Shell] Iframe loaded');

      // Attach iframe to WebSocket service for message relay
      if (iframe && iframe.contentWindow) {
        attachIframe(iframe.contentWindow);
      }
    };

    if (iframe) {
      iframe.addEventListener('load', handleIframeLoad);
    }

    // Listen for messages from iframe
    const handleMessage = (event) => {
      // Only accept messages from our iframe
      if (event.source !== iframe?.contentWindow) return;

      // Only accept messages from same origin
      if (event.origin !== window.location.origin) return;

      console.log('[Shell] Message from iframe:', event.data);

      // Handle iframe messages
      websocketService.handleIframeMessage(event.data);
    };

    window.addEventListener('message', handleMessage);

    return () => {
      if (iframe) {
        iframe.removeEventListener('load', handleIframeLoad);
      }
      window.removeEventListener('message', handleMessage);
      detachIframe();
    };
  }, [attachIframe, detachIframe]);

  return (
    <div className={styles.container}>
      <iframe
        ref={iframeRef}
        src="/aframe-scene.html"
        className={styles.iframe}
        title="VR Scene"
        allow="camera; microphone; accelerometer; gyroscope; magnetometer; xr-spatial-tracking; fullscreen; vr"
        allowFullScreen
      />
    </div>
  );
};

export default VRExperience;
